import { render, staticRenderFns } from "./ProjectWeb.vue?vue&type=template&id=4c0a9039&scoped=true&"
import script from "./ProjectWeb.vue?vue&type=script&lang=ts&"
export * from "./ProjectWeb.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectWeb.vue?vue&type=style&index=0&id=4c0a9039&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0a9039",
  null
  
)

export default component.exports